module.exports = "<p>\r\n  contracts works!\r\n</p>\r\n"